import { apiGet, apiPost, apiPut } from "../../api";
import { urlFindResponsivas, urlResponsiva, urlResponsivaConfigData, urlResponsivaData } from "../../api/urls";
import { RESPONSIVA_STATUS_PENDING, RESPONSIVA_STATUS_PENDING_AFTER_REJECTED } from "../../constants/responsivas";
import { restModelCreator } from "../../utils/effect";
import { getFilters } from "../../utils/filters";
import ResponsiveModel from "../models/responsiva/ResponsiveModel";

export default class ResponsivesEffect {
  static async getResponsives(filter, ownResponsives) {
    let filterData = getFilters(filter);
    const response = await apiPost(urlFindResponsivas, {
      filterData: filterData,
      ownResponsives: ownResponsives,
    });
    // const resp = await new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve([
    //       {
    //         id: "1",
    //         moduleClientId: "CCI",
    //         status: "PENDING",
    //         year: 2025,
    //         requestingUser: {
    //           userLogin: "carlos.perez@aleatica.com",
    //           name: "Carlos",
    //           surName: "Pérez",
    //         },
    //         requestDate: "1735686000",
    //         isAdmin: true,
    //       },
    //       {
    //         id: "2",
    //         moduleClientId: "CCI",
    //         status: "VALIDATED",
    //         year: 2025,
    //         requestingUser: {
    //           userLogin: "manuel.valino@aleatica.com",
    //           name: "Manuel",
    //         },
    //         requestDate: "1735686000",
    //         responsibleUser: {
    //           userLogin: "carlos.perez@aleatica.com",
    //           name: "Carlos",
    //           surName: "Perez",
    //         },
    //       },
    //       {
    //         id: "3",
    //         moduleClientId: "COMAT",
    //         status: "REJECTED",
    //         year: 2025,
    //         requestingUser: {
    //           userLogin: "nicolas.nieto@aleatica.com",
    //           name: "Nicolas",
    //           surname: "Nieto",
    //         },
    //         requestDate: "1735686000",
    //         appManager: {
    //           userLogin: "carlos.perez@aleatica.com",
    //           name: "Carlos",
    //           surName: "Perez",
    //         },
    //         superManagerUser: {
    //           userLogin: "carlos.perez@aleatica.com",
    //           name: "Carlos",
    //           surName: "Perez",
    //         },
    //       },
    //       {
    //         id: "4",
    //         moduleClientId: "SOGO",
    //         status: "REVOKED",
    //         year: 2025,
    //         requestingUser: {
    //           userLogin: "giselle@aleatica.com",
    //           name: "Giselle",
    //         },
    //         requestDate: "1735686000",
    //       },
    //       {
    //         id: "5",
    //         moduleClientId: "MUDE",
    //         year: 2024,
    //         status: "PENDING_AFTER_REJECTED",
    //         requestingUser: {
    //           userLogin: "alicia@aleatica.com",
    //           name: "Alicia",
    //         },
    //         requestDate: "1735686000",
    //       },
    //       {
    //         id: "6",
    //         moduleClientId: "MST",
    //         year: 2025,
    //         status: "PENDING_SUPER_RESPONSIBLE",
    //         requestingUser: {
    //           userLogin: "vero.lopez@aleatica.com",
    //           email: "vero.lopez@aleatica.com",
    //           name: "Vero",
    //         },
    //         requestDate: "1735686000",
    //         isAdmin: true,
    //       },
    //     ]);
    //   }, 500);
    // });
    return restModelCreator(ResponsiveModel, response);
  }
  static async getPendingResponsives() {
    const response = await apiPost(urlFindResponsivas, {
      ownResponsives: false,
      filterData: [
        {
          field: "status",
          value: RESPONSIVA_STATUS_PENDING,
        },
        {
          field: "status",
          value: RESPONSIVA_STATUS_PENDING_AFTER_REJECTED,
        },
      ],
    });
    // // TODO
    // const response = await new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve([{ id: 1 }, { id: 2 }, { id: 3 }]);
    //   }, 500);
    // });
    return response.length;
  }
  static async updateResponsive(responsive) {
    const resp = await apiPut(urlResponsiva, responsive.getId(), responsive.getSaveFields());
    // //TODO
    // const resp = await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve(responsive);
    //   }, [500]);
    // });
    return restModelCreator(ResponsiveModel, resp);
  }
  static async getResponsiveData(responsiveId) {
    const resp = await apiGet(urlResponsivaData(responsiveId));
    // //TODO
    // const resp = await new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ assignedAccesses: "TEST" });
    //   }, [500]);
    // });
    return resp;
  }
  static async getResponsiveConfigData() {
    const resp = await apiGet(urlResponsivaConfigData);
    // //TODO
    // const resp = await new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({
    //       normal: { date: "Ene 2025", revision: "04", code: "SGSI-041", subcode: "F1-002", format: "1.2a" },
    //       admin: { date: "Ene 2025", revision: "03", code: "SGSI-0444", subcode: "F2--003", format: "2.1" },
    //     });
    //   }, [500]);
    // });
    return resp;
  }
}
